export enum DownloadItemType {
  DownloadItem = 'download_item',
  GeneratedDocument = 'generated_document',
}
